var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45833 12.125C1.09167 12.125 0.777778 11.9944 0.516667 11.7333C0.255556 11.4722 0.125 11.1583 0.125 10.7917V1.45833C0.125 1.09167 0.255556 0.777778 0.516667 0.516667C0.777778 0.255556 1.09167 0.125 1.45833 0.125H6.125V1.45833H1.45833V10.7917H10.7917V6.125H12.125V10.7917C12.125 11.1583 11.9944 11.4722 11.7333 11.7333C11.4722 11.9944 11.1583 12.125 10.7917 12.125H1.45833ZM4.59167 8.59167L3.65833 7.65833L9.85833 1.45833H7.45833V0.125H12.125V4.79167H10.7917V2.39167L4.59167 8.59167Z",
    fill: "#203662",
    stroke: "#F0F0F0",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.220ea8b3eef3c0fd87d67fdce0737386.svg";
export { ForwardRef as ReactComponent };